import { React, useEffect } from 'react';
import Nav from './nav';
import Tab from './tabs';

function AdminUND() {
  return (
    <div className="admin-page">
        <body>
            <Tab/>
      </body>
    </div>
  );
}

export default AdminUND;
